module.exports = __webpack_public_path__ + "media/images/story/icon/tulip-icon-d6bf56f1a02c0de55ca83b29024b66bc.png";